import React, { useContext, useEffect, useRef, useState } from 'react';
import L from 'leaflet';
import LayerItem, { ILayerItemProps } from './LayerItem';
import './LayerDialogContent.scss';
import './LayerItem.scss';
import { Divider } from '@mui/material';
import StructureLayers from './StructureLayers';
import { JSDCContext } from '../../../JSDC/Context';

export interface ILayerDialogContentProps {
  layerInfos: Omit<ILayerItemProps, 'onToggleShow' | 'onOpacityChange'>[];
  onToggleShow: (id: string, show: boolean) => void;
  onOpacityChange: (id: string, value: number) => void;
}

const LayerDialogContent: React.FC<ILayerDialogContentProps> = ({
  layerInfos,
  onToggleShow,
  onOpacityChange,
}) => {
  const { trailQuery, advanceListingQuery, trailCreateEvent, advanceCreateEvent } =
    useContext(JSDCContext);
  const [trailsVisible, setTrailsVisible] = useState(true);
  const [advanceVisible, setAdvanceVisible] = useState(true);
  const detachedLayersRef = useRef<L.Layer[]>([]);
  const detachedAdvanceLayersRef = useRef<L.Layer[]>([]);

  // 搜尋（或任何 query）重新填入圖層時會 raise create 事件，此時點位已顯示在地圖上，
  // 把對應 checkbox 恢復勾選並清掉暫存的 detached layers，避免勾選狀態與實際點位不一致。
  useEffect(() => {
    const offTrail = trailCreateEvent.addEventListener(() => {
      setTrailsVisible(true);
      detachedLayersRef.current = [];
    });
    const offAdvance = advanceCreateEvent.addEventListener(() => {
      setAdvanceVisible(true);
      detachedAdvanceLayersRef.current = [];
    });
    return () => {
      offTrail();
      offAdvance();
    };
  }, []);

  const handleToggleTrails = (next: boolean) => {
    setTrailsVisible(next);
    const instance = trailQuery.trailsLayer.instance;
    if (!instance) return;
    if (next) {
      detachedLayersRef.current.forEach((layer) => instance.addLayer(layer));
      detachedLayersRef.current = [];
    } else {
      detachedLayersRef.current = instance.getLayers();
      instance.clearLayers();
    }
  };

  const handleToggleAdvance = (next: boolean) => {
    setAdvanceVisible(next);
    const instance = advanceListingQuery.advanceListingLayer.instance;
    if (!instance) return;
    if (next) {
      detachedAdvanceLayersRef.current.forEach((layer) => instance.addLayer(layer));
      detachedAdvanceLayersRef.current = [];
    } else {
      detachedAdvanceLayersRef.current = instance.getLayers();
      instance.clearLayers();
    }
  };

  return (
    <div className="dui-LayerDialogContent">
      {layerInfos.map((item) => (
        <LayerItem
          key={item.id}
          {...item}
          onToggleShow={(show) => onToggleShow(item.id, show)}
          onOpacityChange={(value) => onOpacityChange(item.id, value)}
        />
      ))}
      <div style={{ marginTop: '20px' }}>
        <Divider />
      </div>
      <div className="dui-LayerDialogContent__footer">
        <div className="dui-LayerItem">
          <input
            type="checkbox"
            checked={trailsVisible}
            onChange={(e) => handleToggleTrails(e.currentTarget.checked)}
          />
          <div className="dui-LayerItem-content">
            <span>環境紀錄</span>
          </div>
        </div>
        <div className="dui-LayerItem">
          <input
            type="checkbox"
            checked={advanceVisible}
            onChange={(e) => handleToggleAdvance(e.currentTarget.checked)}
          />
          <div className="dui-LayerItem-content">
            <span>進階環境紀錄</span>
          </div>
        </div>
        <StructureLayers />
      </div>
    </div>
  );
};
LayerDialogContent.displayName = 'LayerDialogContent';
export default LayerDialogContent;
